import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ProcessamentoArquivo } from '../modelo/Processamento';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })

  export class ProcessamentoService {

    apiUrl: string = `${environment.backendUrl}/processamento`;

    httpOptions = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJHcnVwbyBkZSBUZXN0ZSIsImlzcyI6InVzdWFyaW8udGVzdGUiLCJpYXQiOjE2OTYwMDkzMDYsImV4cCI6MTcwMzg3MTcwNn0.WSfSAzxJZ2UsDOQRwZsnf2F_g5ND8sd10ttfH4uFGYDvzEwh78OsK0cJZ2awjE44qH46D8LWfj5BuyBM168zAg'
        }
    }

    httpOptionsMultiPart = {
        headers: {
            //'Content-Type': 'application/json',
            'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJHcnVwbyBkZSBUZXN0ZSIsImlzcyI6InVzdWFyaW8udGVzdGUiLCJpYXQiOjE2OTYwMDkzMDYsImV4cCI6MTcwMzg3MTcwNn0.WSfSAzxJZ2UsDOQRwZsnf2F_g5ND8sd10ttfH4uFGYDvzEwh78OsK0cJZ2awjE44qH46D8LWfj5BuyBM168zAg'
        }
    }

    constructor(private http: HttpClient) { }

    uploadFile(file: File){
        const formData = new FormData();
          formData.append('file', file);
        return this.http.post(`${this.apiUrl}/arquivo`, 
        formData, { headers: this.httpOptionsMultiPart.headers ,  observe: 'response', responseType: 'text' });  
      }

      getArquivos(): Observable<ProcessamentoArquivo[]> {
        let searchParams = new HttpParams();
        return this.http.get<ProcessamentoArquivo[]>(`${this.apiUrl}/arquivo`);
      }  

  }
  